var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vg_wrapper"},[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"md":9}},[_c('board-left')],1),_c('el-col',{attrs:{"md":9}},[_c('board-right')],1),_c('el-col',{attrs:{"md":6}},[_c('board-push')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }